/**
 * Demo Domain — Public API
 *
 * The Demo domain owns demo seeding end-to-end. The boundary makes the
 * demo system addressable as one unit so that:
 *
 *  - First-time / anonymous users can choose demo explicitly without
 *    pulling demo data into every code path.
 *  - Demo profiles can be registered/extended for the official release
 *    without changing the seeder.
 *  - Tree-shaking remains intact (no side-effect imports).
 *
 * Boot Flow Refactor — mei 2026.
 */

export type {
  DemoLearnerProfile,
  DemoState,
  DemoLearnerGenerator,
} from './types'

export {
  registerDemoProfile,
  registerAllDemoProfiles,
  getDemoProfiles,
  getDemoProfile,
  isDemoRegistryReady,
} from './registry'

export { loadDemoState, seedDemoAssessmentsForState } from './loadDemoState'
